'use client';

import { SessionProvider } from 'next-auth/react';

// Wrapper client-side du SessionProvider NextAuth pour exposer useSession()
// dans les composants client (Header, etc.)
export default function AuthSessionProvider({
  children,
}: {
  children: React.ReactNode;
}) {
  return <SessionProvider>{children}</SessionProvider>;
}
